import styled from 'styled-components';

export const InputContainer = styled.div`
  display: inline-block;
  /* align-items: center;
  justify-content: space-between; */

  position: relative;
`;

export const PrimaryInput = styled.input`
  background-color: #ffffff;
  background-image: none;
  border-width: 1px;
  border-style: solid;
  border-color: #d9d9d9;
  border-radius: 2px;
  transition: all 0.2s;
  margin: 0;
  padding: 4px 11px;
  padding-right: ${(props) => (props.$hasIconAfter ? '36px' : '11px')};
  padding-left: ${(props) => (props.$hasIconBefore ? '36px' : '11px')};
  color: rgba(0, 0, 0, 0.88);
  font-size: 14px;
  line-height: 1.5714285714285714;

  &:hover {
    border-color: #4096ff;
    border-inline-end-width: 1px;
  }

  /* label {
    text-align: right;
    width: 130px;
  }

  label:after {
    content: ':';
  } */
`;

export const IconAfter = styled.div`
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  display: ${(props) => (props.$visible ? 'inline-flex' : 'none')};
  align-items: center;
  justify-content: center;
  color: rgba(0, 0, 0, 0.45);
  pointer-events: auto;
  cursor: pointer;
  /* height: 1.5rem;
  width: 1.5rem;
  background-color: red;
  padding: 4px;
  box-sizing: border-box;
  left: 2px;
  */
`;

export const IconBefore = styled.div`
  position: absolute;
  left: 8px;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: rgba(0, 0, 0, 0.45);
  pointer-events: none;
  /* height: 1.5rem;
  width: 1.5rem;
  background-color: red;
  padding: 4px;
  position: absolute;
  box-sizing: border-box;
  top: 50%;
  left: 2px;
  transform: translateY(-50%); */
`;
